import { ITopBarMessage } from "@cms/utils/interfaces/ui.interface";
import { ActionPayloadType } from "@cms/utils/types";
import { createSlice } from "@reduxjs/toolkit";

interface IAppState {
  navbarOptions: {
    isOpen: boolean;
  };
  sidebarOptions: {
    isOpen: boolean;
  };
  topBarOptions: {
    messages: Record<string, ITopBarMessage | undefined>;
  };
}

const initialState: IAppState = {
  navbarOptions: {
    isOpen: false,
  },
  sidebarOptions: {
    isOpen: false,
  },
  topBarOptions: {
    messages: {},
  },
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    toggleSidebarAction: (state) => {
      return {
        ...state,
        sidebarOptions: {
          ...state.sidebarOptions,
          isOpen: !state.sidebarOptions.isOpen,
        },
      };
    },

    toggleNavbarAction: (state) => {
      return {
        ...state,
        navbarOptions: {
          ...state.navbarOptions,
          isOpen: !state.navbarOptions.isOpen,
        },
      };
    },

    setSidebarOptionsAction: (
      state,
      action: ActionPayloadType<Partial<IAppState["sidebarOptions"]>>,
    ) => {
      return {
        ...state,
        sidebarOptions: {
          ...state.sidebarOptions,
          ...action.payload,
        },
      };
    },

    setNavbarOptionsAction: (
      state,
      action: ActionPayloadType<Partial<IAppState["navbarOptions"]>>,
    ) => {
      return {
        ...state,
        navbarOptions: {
          ...state.navbarOptions,
          ...action.payload,
        },
      };
    },

    showTopBarMessageAction: (
      state,
      action: ActionPayloadType<ITopBarMessage & { pageId: string }>,
    ) => {
      const { pageId, ...message } = action.payload;

      return {
        ...state,
        topBarOptions: {
          ...state.topBarOptions,
          messages: {
            ...state.topBarOptions.messages,
            [pageId]: message,
          },
        },
      };
    },

    hideTopBarMessageAction: (
      state,
      action: ActionPayloadType<{ pageId: string }>,
    ) => {
      return {
        ...state,
        topBarOptions: {
          ...state.topBarOptions,
          messages: {
            ...state.topBarOptions.messages,
            [action.payload.pageId]: undefined,
          },
        },
      };
    },
  },
});

export const {
  toggleSidebarAction,
  setSidebarOptionsAction,
  toggleNavbarAction,
  setNavbarOptionsAction,
  showTopBarMessageAction,
  hideTopBarMessageAction,
} = appSlice.actions;

export default appSlice.reducer;
